module.exports = __webpack_public_path__ + "static/img/org_title9.17d4997.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/org_title9.png
// module id = oIOP
// module chunks = 4